import styled from "styled-components";

export const ContainerNotificacao = styled.section`
  padding: 32px 0;
  background: #ffffff;

  @media only screen and (max-width: 980px) {
    padding: 16px 0;
    margin-top: 0px;
  }
`;

export const ListaNotificacoes = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
`;

export const ContainerPaginator = styled.div`
  width: 100%;
  padding: 16px 0 8px 0;

  display: flex;
  align-items: center;
  justify-content: center;
`;
